import React, { useEffect } from "react";
import styles from './index.css';
import datePickerStyles from "react-day-picker/style.css";

import { createRoot } from "react-dom/client";
import RedSeaSearch from "./widgets/redSeaSearch.jsx";
import root from 'react-shadow';

const mountNodes = document.querySelectorAll("[data-search-form]");
mountNodes.forEach(mountNode => {

  createRoot(mountNode).render(<root.div >
    <RedSeaSearch
      baseUrl={mountNode.dataset.baseUrl}
      specificSearch={JSON.parse(mountNode.dataset.specificSearch ?? null)}
      specificAccom={JSON.parse(mountNode.dataset.specificAccom ?? null)}
     />
    <style type="text/css">{styles}</style>
    <style type="text/css">{datePickerStyles}</style>
  </root.div>
  );
});

window.RedSeaSearch = ({ mountNode, baseUrl, specificSearch }) => {
  console.log("Mounting RedSeaSearch JS Api", { mountNode, baseUrl, specificSearch });

  createRoot(mountNode)
    .render(<root.div >
      <RedSeaSearch
        baseUrl={baseUrl}
        specificSearch={specificSearch}
      />
      <style type="text/css">{styles}</style>
      <style type="text/css">{datePickerStyles}</style>
    </root.div>
    );
} 